<div>
	<!-- {{ salon.getName() }} -->
	<div [innerHtml]="salonCancellationPolicy" class="sm-cancellation-policy"></div>
	<a class='sm-powered-by' href='https://salonmonster.com/?src=bookingwidget'>powered by salonMonster</a>
</div>